import { atomFamily, selector, waitForAll } from 'recoil';
import { type BlockId } from './types';
import { allBlockIdsState } from './grid';

export const blockLoadingState = atomFamily<boolean, BlockId>({
  key: 'blockLoading',
  default: false,
});

export const blocksLoadingState = selector<boolean>({
  key: 'blocksLoading',
  get: ({ get }) => {
    const blockIds = get(allBlockIdsState);
    const blockLoadingStates = get(waitForAll(blockIds.map((id) => blockLoadingState(id))));

    return blockLoadingStates.some(Boolean);
  },
});
